export const trackingEvents = {
  SAVE_BUTTON: {
    CLICKED: 'user_settings.save_button.clicked',
  },
}
